import {Menu} from '@core/modules/layout/interfaces/menu.interface';
import {MENU} from '@core/modules/layout/constants/menu.const';

export abstract class MenuComponent {
  public menu: Menu[] = MENU;
}
